import React from 'react';

import { TextField, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

import { t, number } from '~/helpers';

import * as S from './styles';

/**
 * LEGEND (error)
 *
 * (1) Divergência de volume
 */
export default function Tanques({
  tanque,
  sending,
  onForm,
  error,
  position,
  close,
}) {
  React.useEffect(() => {
    if (sending) {
      onForm({ position, error });
      close();
    }
  }, [sending]);

  if (error === 1)
    return (
      <S.Wrapper>
        <Typography>
          {t('s.operacao.turno.divergenciavolume').replace(
            '%',
            tanque.codigotanquefisico
          )}
        </Typography>
        <S.WrapperGroupInput>
          <TextField
            fullWidth
            disabled
            size="small"
            variant="outlined"
            label={t('s.operacao.turno.alturatanquefisico')}
            value={number(tanque.alturatanquefisico, 1)}
          />

          <TextField
            fullWidth
            disabled
            size="small"
            variant="outlined"
            label={t('s.operacao.turno.volumetanquefisico')}
            value={number(tanque.volumetanquefisico, 1)}
          />
        </S.WrapperGroupInput>
      </S.Wrapper>
    );

  return (
    <S.Wrapper>
      <Typography>
        {t('s.operacao.turno.divergenciavolumeturnoAnterior')}
      </Typography>
    </S.Wrapper>
  );
}

Tanques.propTypes = {
  tanque: PropTypes.objectOf({
    idtanquefisico: PropTypes.number,
    alturatanquefisico: PropTypes.number,
    volumetanquefisico: PropTypes.number,
    alturaaguatanquefisico: PropTypes.number,
    volumeaguatanquefisico: PropTypes.number,
    codigotanquefisico: PropTypes.string,
  }),
  sending: PropTypes.bool.isRequired,
  onForm: PropTypes.func.isRequired,
  error: PropTypes.number,
  position: PropTypes.number,
  close: PropTypes.func.isRequired,
};

Tanques.defaultProps = {
  tanque: {
    idtanquefisico: 0,
    alturatanquefisico: 0,
    volumetanquefisico: 0,
    alturaaguatanquefisico: 0,
    volumeaguatanquefisico: 0,
    codigotanquefisico: '',
  },
  error: 1,
  position: 0,
};
